module.exports = "/images/AssignAPackage_2of2.jpg";